import { render } from "./agreement.vue?vue&type=template&id=7db592c0&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=js"
export * from "./agreement.vue?vue&type=script&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=7db592c0&scoped=true&lang=css"

import exportComponent from "/Users/h5/Desktop/project/京南广告/cheyidai/chn-link/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db592c0"]])

export default __exports__